import SelectComponent from 'components/Select';
import PropTypes from 'prop-types';

import { ReactComponent as CheckIcon } from 'icons/components/check.svg';

import './index.less';
import './themes/default.less';

export default class MultiSelect extends SelectComponent {
    static propTypes = {
        ...SelectComponent.propTypes,
        min: PropTypes.number,
    };
    static defaultProps = {
        ...SelectComponent.defaultProps,
        min: 0,
    };

    get mainClassName() {
        return "select multiSelect";
    }

    selectItem(index, { id }) {
        const { min } = this.props;
        const { selected } = this.state;
        const i = selected.indexOf(id);

        if (i > -1) {
            if (min > 0 && selected.length <= min)
                return;

            selected.splice(i, 1);
        }
        else
            selected.push(id);

        this.setState({ selected });

        if (this.props.onChange)
            this.props.onChange(selected);
    }

    getPopupItemStyle({ id }) {
        const cl = this.state.selected.includes(id) ? " active" : "";

        return "popupItem hand" + cl;
    }

    getPopupItemLabel(info) {
        return (
            <div className="checkboxCont flex centerV gap8">
                <div className="checkbox flex centerAll">
                    <CheckIcon />
                </div>
                {info[this.props.labelKey]}
            </div>
        );
    }

    checkSelectedValue() {
        if (this.props.selected)
            this.state.selected = this.props.selected;

        return super.checkSelectedValue(...arguments);
    }
}
